import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectCurrentUserState = (state: RootState) => state.currentUser;

export const selectIsLoading = createSelector(
  selectCurrentUserState,
  (currentUserState) => currentUserState.isLoading
);

export const selectIsLoadingUpdate = createSelector(
  selectCurrentUserState,
  (currentUserState) => currentUserState.isLoadingUpdate
);

export const selectIsAuthorized = createSelector(
  selectCurrentUserState,
  (currentUserState) => currentUserState.isAuthorized
);

export const selectCurrentUser = createSelector(
  selectCurrentUserState,
  (currentUserState) => currentUserState.currentUser
);
